import React from "react";
import { anatomyConstants } from "../../../constants/anatomyConstants";

function CenterlineModal({
  isOpen,
  onToggleCenterline,
  onSelectPoints,
  onToggleCameraSliderModal,
  onToggleSectionViewSliderModal,
  isMobile,
}) {
  if (!isOpen) return null;

  // Check if mobile portrait (upside down) view
  const isMobilePortrait =
    isMobile &&
    typeof window !== "undefined" &&
    window.innerWidth < window.innerHeight;

  return (
    <div
      className={`absolute ${
        isMobilePortrait ? "bottom-20 left-2" : "bottom-1 left-28"
      } w-auto flex flex-col items-center z-50`}
    >
      <div
        className="relative flex flex-col items-center space-y-2 px-3 pt-7 pb-3 bg-white rounded-lg shadow-lg border border-gray-200 w-36"
        style={{
          "--main-color": anatomyConstants.mainColor,
          "--main-color-bold": anatomyConstants.mainColorBold,
        }}
      >
        <button
          onClick={(e) => {
            e.stopPropagation();
            onToggleCenterline();
          }}
          className="w-full py-2 px-3 text-sm font-inter font-medium text-white rounded bg-[var(--main-color)] hover:bg-[var(--main-color-bold)] border border-[#0000001A]"
        >
          Extract Centerline
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onSelectPoints();
          }}
          className="w-full py-2 px-3 text-sm font-inter font-medium text-white rounded bg-[var(--main-color)] hover:bg-[var(--main-color-bold)] border border-[#0000001A]"
        >
          Extract Shortest Path
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onToggleCameraSliderModal();
          }}
          className="w-full py-2 px-3 text-sm font-inter font-medium text-white rounded bg-[var(--main-color)] hover:bg-[var(--main-color-bold)] border border-[#0000001A]"
        >
          Camera View
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onToggleSectionViewSliderModal();
          }}
          className="w-full py-2 px-3 text-sm font-inter font-medium text-white rounded bg-[var(--main-color)] hover:bg-[var(--main-color-bold)] border border-[#0000001A]"
        >
          Section View
        </button>
      </div>
    </div>
  );
}

export default CenterlineModal;
